export const ROLE_ESHOP = 'hcp_eshop'
export const ROLE_PRICELIST = 'hcp_pricelist'
